import { render, staticRenderFns } from "./Reporte.vue?vue&type=template&id=3836ab93"
import script from "./Reporte.vue?vue&type=script&lang=js"
export * from "./Reporte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports